/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TenantConfig } from '../../models/tenant-config';

export interface GetConfig$Params {
  id: string;
}

export function getConfig(http: HttpClient, rootUrl: string, params: GetConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TenantConfig>>> {
  const rb = new RequestBuilder(rootUrl, getConfig.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TenantConfig>>;
    })
  );
}

getConfig.PATH = '/api/tenants/{id}/configs';
